import { useState } from 'react';

function Section({ title, icon, children }) {
    const [open, setOpen] = useState(true);
    return (
        <div className="aaw-card">
            <button
                type="button"
                className={`aaw-card-header ${open ? 'aaw-card-open' : ''}`}
                onClick={() => setOpen(o => !o)}
            >
                <span>{icon}</span>
                <span className="aaw-card-title">{title}</span>
                <span className="aaw-card-chevron">{open ? '▲' : '▼'}</span>
            </button>
            {open && <div className="aaw-card-body">{children}</div>}
        </div>
    );
}

function KV({ label, value }) {
    if (!value && value !== 0) return null;
    return (
        <div className="aaw-row-kv">
            <span className="aaw-kv-label">{label}</span>
            <span className="aaw-kv-value">{value}</span>
        </div>
    );
}

export default function Step6_Review({ data, onBack, onSubmit, submitting, error }) {
    const docs = data.documents || [];
    const nbrs = data.preferred_neighborhoods || [];

    return (
        <div>
            <h2 className="aaw-step-title">بررسی و ارسال</h2>
            <p className="aaw-step-desc">اطلاعات ثبت‌شده را مرور کنید و سپس درخواست را ارسال نمایید.</p>

            <div className="aaw-review-body">
                <Section title="اطلاعات شخصی" icon="👤">
                    <KV label="نام کامل" value={data.full_name} />
                    <KV label="کد ملی" value={data.national_id} />
                    <KV label="تلفن" value={data.phone} />
                    <KV label="ایمیل" value={data.email} />
                </Section>

                <Section title="اطلاعات مکانی" icon="📍">
                    <KV label="استان" value={data.province} />
                    <KV label="شهر" value={data.city} />
                    <KV label="آدرس" value={data.address} />
                </Section>

                <Section title="سابقه و انگیزه" icon="💼">
                    <KV label="سابقه کاری" value={data.years_of_experience != null ? `${data.years_of_experience} سال` : null} />
                    <KV label="انگیزه" value={data.motivation} />
                </Section>

                <Section title="محله‌های مورد نظر" icon="🗺️">
                    {nbrs.length === 0
                        ? <span style={{ fontSize: '0.85rem', color: '#b0bec5' }}>انتخاب نشده</span>
                        : (
                            <div className="aaw-nbr-chips" style={{ paddingTop: 4 }}>
                                {nbrs.map(n => (
                                    <span key={n.id} className="aaw-nbr-chip">{n.name}</span>
                                ))}
                            </div>
                        )
                    }
                </Section>

                <Section title="مدارک" icon="📎">
                    {docs.length === 0
                        ? <span style={{ fontSize: '0.85rem', color: '#b0bec5' }}>مدرکی بارگذاری نشده</span>
                        : docs.map((d, i) => (
                            <div key={i} className="aaw-row-kv">
                                <span className="aaw-kv-label">{d.label}</span>
                                <span className="aaw-kv-value">{d.file?.name}</span>
                            </div>
                        ))
                    }
                </Section>
            </div>

            {error && <p className="aaw-error">{error}</p>}

            <div className="aaw-nav">
                <button className="aaw-btn aaw-btn-secondary" onClick={onBack} disabled={submitting}>
                    → مرحله قبل
                </button>
                <button
                    className="aaw-btn aaw-btn-submit"
                    onClick={onSubmit}
                    disabled={submitting}
                >
                    {submitting ? 'در حال ارسال...' : 'ارسال درخواست ✓'}
                </button>
            </div>
        </div>
    );
}
